var map;

var BlsCreateMapStoreLocation = (function () {
    return {
        init: function () {
            mapboxgl.accessToken = 'pk.eyJ1IjoiZGFudWJlaG9zcGl0YWxpdHkiLCJhIjoiY210cXVwNDdzMGxldTJ4cXVmNXlmaThneSJ9.zFvcRDhsUqrafatKhCNYiA';

            const stores = document.querySelectorAll('.store-infor__items');

            const storeArray = Array.from(stores).map((element) => {
                return {
                    type: 'Feature',
                    geometry: {
                        type: "Point",
                        coordinates: [
                            Number(element.dataset.lng),
                            Number(element.dataset.lat)
                        ]
                    },
                    properties: {
                        phone: element.dataset.phone,
                        address: element.dataset.address,
                        name: element.dataset.name
                    }
                };
            });

            const listStore = {
                type: 'FeatureCollection',
                features: storeArray
            };

            listStore.features.forEach((store, index) => {
                store.properties.id = `store_${index}`;
            });

            map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/mapbox/light-v11',
                center: [55.242940009854124, 25.121209525223605],
                zoom: 12,
                pitch: 60,
                bearing: 0
            });

            map.addControl(
                new MapboxGeocoder({
                    accessToken: mapboxgl.accessToken,
                    mapboxgl: mapboxgl
                }),
                'top-left'
            );

            map.on('load', () => {

                map.addSource('places', {
                    type: 'geojson',
                    data: listStore
                });

                map.getStyle().layers.forEach(layer => {
                    try {
                        if (layer.type === 'background') {
                            map.setPaintProperty(layer.id, 'background-color', '#F4F0E7');
                        }

                        if (layer.type === 'fill') {
                            map.setPaintProperty(layer.id, 'fill-color', '#DDD6C8');
                        }

                        if (layer.type === 'line') {
                            map.setPaintProperty(layer.id, 'line-color', '#BFB7A7');
                        }

                        if (layer.type === 'symbol' && layer.paint && layer.paint['text-color']) {
                            map.setPaintProperty(layer.id, 'text-color', '#8A8479');
                        }
                    } catch (e) {}
                });

                this.addMarker(listStore);
                this.storeInforAction(listStore);

                setTimeout(() => map.resize(), 100);
                setTimeout(() => map.resize(), 500);
                setTimeout(() => map.resize(), 1000);
                setTimeout(() => map.resize(), 2000);
            });

            window.addEventListener('resize', () => {
                map.resize();
            });
        },
        addMarker: function (listStore) {
            listStore.features.forEach(store => {
                const marker = document.createElement('div');
                marker.id = `marker-${store.properties.id}`;
                marker.addEventListener('click', e => {
                    this.createPopupMarker(store);
                    this.zoomMarker(store)
                })
                marker.classList.add('marker');
                new mapboxgl.Marker(marker, { offset: [0, -23] })
                    .setLngLat(store.geometry.coordinates)
                    .addTo(map);
            })
        },
        createPopupMarker: function (listStore) {
            const closePopup = document.getElementsByClassName('mapboxgl-popup');
            if (closePopup[0]) closePopup[0].remove();

            const { address, phone, name } = listStore.properties;
            const popup = new mapboxgl.Popup({ closeOnClick: false })
                .setLngLat(listStore.geometry.coordinates)
                .setHTML(`<h3>${name}</h3><div>${address}<br>${phone}</div>`)
                .addTo(map)
            let closeButton = document.querySelector(".bls__location-page .mapboxgl-popup-close-button")
            if(closeButton)
                 closeButton.innerHTML = `<svg width="13" height="13" viewBox="0 0 13 13" fill="white" class="transition">
            <use href="#icon-close" />
          </svg>`
        },
        zoomMarker: function (listStore) {
            map.flyTo({
                center: listStore.geometry.coordinates,
                zoom: 15,
            })
        },
        storeInforAction: function (listStore) {
            const listStoresInfor = document.querySelectorAll('.ourstore-info-wrapper');

            listStoresInfor.forEach((item, index) => {
                item.addEventListener("click", e => {
                    e.preventDefault();
                    e.stopPropagation();

                    const storeItem = item.querySelector('.store-infor__items');

                    if (!storeItem.classList.contains('store-active')) {
                        document.querySelectorAll('.store-infor__items').forEach(el => {
                            el.classList.remove('store-active');
                        });

                        storeItem.classList.add('store-active');
                    } else {
                        storeItem.classList.remove('store-active');
                    }

                    const currentFeature = listStore.features[index];

                    this.createPopupMarker(currentFeature);
                    this.zoomMarker(currentFeature);
                });
            });
        }
    }
})();
document.addEventListener("DOMContentLoaded", () => {
    BlsCreateMapStoreLocation.init();
});